import React, { PureComponent } from "react";
import cx from "classnames";
import PubSub from "pubsub-js";
import { resetPassword as resetPasswordSchema } from "@maxmilhas/max-validator";
import { resetPassword } from "../../shared/requests-api";

const PasswordInput = React.forwardRef(
	({ children, className, name, errorMessage, ...rest }, ref) => (
		<div className={className} data-tooltip={errorMessage} data-flow="down">
			<label htmlFor={name}>{children}</label>
			<input
				ref={ref}
				aria-required="true"
				className="form-control no-shadow no-bold"
				id={name}
				name={name}
				type="password"
				autocomplete="off"
				required
				{...rest}
			/>
		</div>
	)
);

const PasswordRules = ({ rules, ...rest }) => {
	const hasLenghtError = rules && rules.includes("min");
	const hasRegexError = rules && rules.includes("regex");

	const rulesClass = cx("password-rules", {
		passed: !hasLenghtError && !hasRegexError
	});
	const titleRuleClass = cx("title", {
		passed: !hasLenghtError && !hasRegexError
	});
	const lengthRuleClass = cx("length", {
		passed: !hasLenghtError
	});
	const regexRuleClass = cx("letter-and-number", {
		passed: !hasRegexError
	});
	return (
		<div {...rest}>
			<ul id="password_rules" className={rulesClass}>
				<li className={titleRuleClass} id="password_title">
					Sua senha deve:
				</li>
				<li className={lengthRuleClass}>
					<i className={hasLenghtError ? "icon-close" : "icon-check"} id="password_mindig" />Ter no
					mínimo 8 dígitos.
				</li>
				<li className={regexRuleClass}>
					<i className={hasRegexError ? "icon-close" : "icon-check"} id="password_numblet" />Ter ao
					menos uma letra e um número.
				</li>
			</ul>
		</div>
	);
};

const Header = ({ children, ...rest }) => (
	<div {...rest}>
		<h3 className="lead">{children}</h3>
	</div>
);

export default class extends PureComponent {
	static displayName = "NewPassword";

	state = {
		isSaving: false,
		errorMessage: undefined,
		failedRules: ["min", "regex"]
	};

	constructor(...args) {
		super(...args);
		this.passwordInputRef = React.createRef();
		this.confirmPasswordInputRef = React.createRef();
	}

	handleSubmit = async event => {
		event.preventDefault();
		const { token } = this.props.match.params;
		try {
			this.setState({ isSaving: true, errorMessage: undefined });
			const { newPassword } = await this.validate();
			const resp = await resetPassword(token, newPassword);

			PubSub.publish("dataLayer", {
				event: "gaEvent",
				gaEventCategory: "Redefinição de senha",
				gaEventAction: "Nova senha criada",
				gaEventLabel: ""
			});

			const { data } = resp;
			if (data && data.flow === "comprar") {
				window.location = `/busca-passagens-aereas/pagamento?id=${data.hash}`;
			} else {
				window.location.pathname = "/";
			}
		} catch (error) {
			const { name } = error;
			let errorMessage;
			const wasAPIError = error.response && error.response.status;

			if (wasAPIError) {
				const { data } = error.response;
				if (error.response.status === 404) {
					// Token was not found
					errorMessage = data.message;
				} else if (error.response.status === 422) {
					// Invalid password format
					const [firstError] = data.detail;
					errorMessage = firstError.message;
				} else if (error.response.status === 409) {
					// Token duplicated
					errorMessage = "Este token já está em uso";
				}
			} else if (name === "ValidationError") {
				const [firstError] = error.errors;
				errorMessage = firstError;
			} else if (typeof error === "string") {
				errorMessage = error;
			} else {
				errorMessage = "Erro ao tentar redefinir sua senha";
			}
			this.setState({ isSaving: false, errorMessage });
		}
	};

	handleInputChange = async e => {
		this.setState({ errorMessage: undefined });
		try {
			await this.validate({ abortEarly: false });
		} catch (e) {
			const errors = e.inner
				.filter(v => v.path === "newPassword" && (v.type === "min" || v.params.regex))
				.map(v => v.type || "regex");
			this.setState({ failedRules: errors });
		}
	};

	validate = async opts => {
		const newPassword = this.passwordInputRef.current.value;
		const confirmPassword = this.confirmPasswordInputRef.current.value;

		return resetPasswordSchema.validate(
			{
				newPassword,
				confirmPassword
			},
			opts
		);
	};

	render() {
		const { isSaving, errorMessage, failedRules } = this.state;
		const formGroupClasses = cx("form-group", {
			"has-error": !!errorMessage
		});

		return (
			<div className="recoverpage">
				<section className="container-fluid">
					<Header className="general-info">Nova senha</Header>
					<div className="authentication-wrapper">
						<form className="new-card" onSubmit={this.handleSubmit}>
							<header className="new-card__header ">
								<h3 className="new-card__title">Crie sua nova senha</h3>
							</header>

							<div className="new-card__content">
								<div className="row">
									<div className="col-lg-3 col-md-4 col-xs-16">
										<PasswordInput
											className={formGroupClasses}
											ref={this.passwordInputRef}
											name="newPassword"
											placeholder="Digite sua nova senha"
											aria-label="Digite sua nova senha"
											autoComplete="new-password"
											disabled={isSaving}
											onChange={this.handleInputChange}
										>
											Nova Senha
										</PasswordInput>
									</div>
									<div className="col-lg-3 col-md-4 col-xs-16">
										<PasswordInput
											className={formGroupClasses}
											errorMessage={errorMessage}
											ref={this.confirmPasswordInputRef}
											name="confirmPassword"
											placeholder="Confirme sua senha"
											aria-label="Confirme sua senha"
											disabled={isSaving}
											autoComplete="new-password"
											onChange={this.handleInputChange}
										>
											Confirmar a nova senha
										</PasswordInput>
									</div>

									<div className="col-lg-3 col-md-4 col-xs-16">
										<button
											type="submit"
											name="button"
											className="btn btn-success"
											disabled={isSaving}
										>
											Confirmar alterações
										</button>
									</div>
								</div>

								<div className="row">
									<div className="col-lg-6 col-md-8 col-xs-16">
										<PasswordRules className="box-recovery" rules={failedRules} />
									</div>
								</div>
							</div>
						</form>
					</div>
				</section>
			</div>
		);
	}
}
